/* Built In Imports */

/* External Imports */
import { Box, Skeleton } from '@chakra-ui/react';
import { Suspense } from 'react';

/* Internal Imports */
/* Components */

/* Services */

// Utils

/**
 * Renders the Style Config on sectionId
 * @param {Object} StyleConfig- Data for section
 * @param {Object} children - Child Elements
 * @param {string} id - id
 * @returns {ReactElement} Designs style config for children component
 */
const StyleConfig = ({
  id,
  children,
  style,
  section,
  bottomAngled,
  region,
  width,
  ...props
}) => {
  const overlapObj = {
    '': 2,
    default: 2,
    'overlap-front': 3,
    'overlap-back': 0,
  };

  const mtObj = {
    '': 0,
    default: 0,
    'overlap-front': {
      base: '-80px',
      md: '-11%',
      lg: '-120px',
    },
    'overlap-back': { base: '-80px', md: '-120px', lg: '-120px' },
  };

  return style?._modelApiKey && Object.keys(style)?.length > 0 ? (
    <Suspense fallback={<Skeleton />}>
      <Box
        // ? implement image_repeat_type property
        width="100%"
        position="relative"
        id={id}
        w={width}
        // clipPath={
        //   style?.angledSection
        //     ? `polygon(0 2%, 100% 0, 100% 100%, 0% 93%)`
        //     : bottomAngled
        //     ? `polygon(0 0, 100% 0, 100% 100%, 0% 98%)`
        //     : 'unset'
        // }
        clipPath={{
          base: style?.angledSection
            ? `polygon(0 2%, 100% 0, 100% 100%, 0% 95%)`
            : bottomAngled
            ? `polygon(0 0, 100% 0, 100% 100%, 0% 98%)`
            : 'unset',
          xl: style?.angledSection
            ? `polygon(0 2%, 100% 0, 100% 100%, 0% 93%)`
            : bottomAngled
            ? `polygon(0 0, 100% 0, 100% 100%, 0% 98%)`
            : 'unset',
        }}
        // padding="60px"
        pt={{
          base: style?.angledSection
            ? '104px'
            : props.pT || props.pT?.base || '0',
          md: style?.angledSection ? '80px' : props.pT || props.pT?.md || '0',
        }}
        pb={props.pB || '0'}
        mb={style?.additionalBottomPadding ? props.mB || '0' : '0'}
        bgColor={style?.bgColour?.hex || null}
        bgImage={style?.bgImage?.url || null}
        display="flex"
        bgRepeat="none"
        flexDirection="column"
        bgSize="cover"
        zIndex={overlapObj[section?.styleConfig?.overlap]}
        mt={mtObj[section?.styleConfig?.overlap]}
        {...props}
      >
        {children}
      </Box>
    </Suspense>
  ) : (
    <Suspense fallback={<Skeleton />}>
      <Box width="100%" position="relative" id={id} zIndex="2">
        {children}
      </Box>
    </Suspense>
  );
};

export default StyleConfig;
